import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import JoinBookforge from "@/components/JoinBookforge";
import TrialBanner from "@/components/TrialBanner";
import WhatsNewBell from "@/components/WhatsNewBell";

export default function SiteNav({ variant = "app" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const onMarketing = variant === "marketing";

  return (
    <header
      className="sticky top-0 z-40 glass border-b"
      style={{ borderColor: "var(--bf-border)" }}
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
          <span
            className="w-8 h-8 rounded-md flex items-center justify-center font-serif text-lg"
            style={{ background: "var(--bf-primary)", color: "white" }}
          >
            B
          </span>
          <span className="font-serif text-2xl">Bookforge</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm" style={{ color: "var(--bf-text-muted)" }}>
          {onMarketing && (
            <>
              <a href="#features" className="hover:text-[color:var(--bf-text)]" data-testid="nav-features">Features</a>
              <a href="#flow" className="hover:text-[color:var(--bf-text)]" data-testid="nav-flow">How it works</a>
              <a href="#publicity" className="hover:text-[color:var(--bf-text)]" data-testid="nav-publicity">Publicity</a>
            </>
          )}
          {user && (
            <>
              {user.role === "publisher" ? (
                <Link to="/publisher" className="hover:text-[color:var(--bf-text)]" data-testid="nav-publisher-dashboard">Publisher console</Link>
              ) : (
                <Link to="/dashboard" className="hover:text-[color:var(--bf-text)]" data-testid="nav-dashboard">My Books</Link>
              )}
              <Link to="/publishers" className="hover:text-[color:var(--bf-text)]" data-testid="nav-publishers-dir">Publishers</Link>
              {user.role === "admin" && (
                <Link to="/admin" className="hover:text-[color:var(--bf-text)]" data-testid="nav-admin">Admin</Link>
              )}
            </>
          )}
          {!user && !onMarketing && (
            <Link to="/publishers" className="hover:text-[color:var(--bf-text)]" data-testid="nav-publishers-dir-public">Publishers</Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {!user && onMarketing && (
            <JoinBookforge label="I'm interested in Bookforge" className="hidden sm:inline-flex" />
          )}
          {!user && (
            <>
              <Link to="/login" data-testid="nav-login">
                <Button variant="ghost" className="text-sm" data-testid="nav-login-btn">Sign in</Button>
              </Link>
              <Link to="/register" data-testid="nav-register">
                <Button
                  className="text-sm text-white"
                  style={{ background: "var(--bf-primary)" }}
                  data-testid="nav-register-btn"
                >
                  Start writing
                </Button>
              </Link>
            </>
          )}
          {user && (
            <>
              <WhatsNewBell />
              <span className="text-sm hidden sm:inline" data-testid="nav-user-name">
                {user.name}
              </span>
              <Button
                variant="outline"
                className="text-sm"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                data-testid="nav-logout-btn"
              >
                Log out
              </Button>
            </>
          )}
        </div>
      </div>
      {user && !onMarketing && <TrialBanner />}
    </header>
  );
}
